module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _c('items-list', {
    staticClass: "active",
    attrs: {
      "data-tab": "shop",
      "db": _vm.db,
      "uservalid": _vm.uservalid
    }
  }), _c('notes-list', {
    attrs: {
      "data-tab": "note",
      "db": _vm.db,
      "uservalid": _vm.uservalid
    }
  }), _c('settings-list', {
    attrs: {
      "data-tab": "settings",
      "db": _vm.db
    },
    on: {
      "validchange": _vm.set_valid
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui three item labeled icon menu bottom fixed"
  }, [_c('a', {
    staticClass: "item active",
    attrs: {
      "data-tab": "shop"
    }
  }, [_c('i', {
    staticClass: "shopping basket icon"
  })]), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "note"
    }
  }, [_c('i', {
    staticClass: "book icon"
  })]), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "settings"
    }
  }, [_c('i', {
    staticClass: "setting icon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa990ce8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 58
// module chunks = 0